/**
 * Seeds cancel/reject default reason text once non-dashboard translations are ready (request email scopes).
 */
import { useEffect } from "react";
import useTranslation from "../../../../../translation/hooks/translation-hook";
import type { IActionReasonField } from "../../rma-types";

interface IProps {
    kind: "cancel" | "reject";
    reasonField: IActionReasonField | undefined;
}

const RmaActionModalDefaultReasonEffect: React.FC<IProps> = ({ kind, reasonField }) => {
    const { getTranslation, isLoading } = useTranslation();

    useEffect(() => {
        const defaultText =
            kind === "cancel"
                ? getTranslation("GENERIC_CANCEL_REASON") ?? "Canceled to your request"
                : getTranslation("GENERIC_REJECT_REASON") ?? "See return policy";

        if (!isLoading) {
            reasonField?.onChange(defaultText);
        }
    }, [kind, reasonField, getTranslation, isLoading]);

    return null;
};

export default RmaActionModalDefaultReasonEffect;
